import enUS from './en-US.json';
import frFR from './fr-FR.json';

export { enUS, frFR };
